module.exports = __webpack_public_path__ + "img/card-3.12031e46.png";